import React from "react";

export const questionData = [
  {id:1,
    question: 'What is this website for?',
    type: 'Radio',
    options: [
      { id:0, value: 'Lead generation', hours:5},
      { id:1, value: 'Informational', hours:0},
      { id:2, value: 'eCommerce', hours:90},
      { id:3, value: 'Anything else (please mention)', extra: {type: 'Textarea'}, hours:0}
    ]
  },
  {id:2,
    question: 'Total number of unique pages:',
    type: 'Radio',
    options: [
      { id:21, value: 'Up to 5', hours:80},
      { id:22, value: '6-20', hours:130},
      { id:23, value: 'more than 20', hours:160}
    ]
  },
  {id:3,
    question: 'Design Theme:',
    type: 'Radio',
    options: [
      { id:31, value: 'To be built from scratch', hours:[45, 75, 95]},
      { id:32, value: 'Using an existing template', hours:[20, 40, 60]},
      { id:33, value: 'I have the designs', hours:10},
      { id:34, value: 'I need help with the designs', hours:10},
      { id:35, value: 'No idea', hours:0}
    ]
  },
  {id:4,
    question: 'Has a blog?',
    type: 'Radio',
    options: [
      { id:41, value: 'Yes', hours:30},
      { id:42, value: 'No', hours:0},
      { id:43, value: 'Not decided', hours:0}
    ]
  },
  {id:5,
    question: 'Are you migrating from an existing CMS?',
    type: 'Conditional',
    options: [
      { id:51, value: 'Yes', hours:0},
      { id:52, value: 'No it’s a new website', hours:0}
    ],
    subQues: [
      {
        id: 1,
        type: 'Radio',
        question: 'Which CMS?',
        options: [
          { id:511, value: 'WordPress', hours:0},
          { id:512, value: 'Drupal', hours:0},
          { id:513, value: 'EPS server', hours:0},
          { id:514, value: 'Wix', hours:0},
          { id:515, value: 'Divi (WordPress)', hours:0},
          { id:516, value: 'Headless CMS', hours:0},
          { id:517, value: 'Other', hours:0}
        ]
      },
      {
        id: 2,
        type: 'Radio',
        question: 'Who will migrate the content?',
        options: [
          { id:521, value: 'We have a team', hours:0},
          { id:522, value: 'We need help with migration', hours:[15, 30, 50]}
        ]
      }
    ]
  },
  {id:6,
    question: 'Special features you want in the website:',
    type: 'Checkbox',
    options: [
      { id:61, value: 'Lead gen form', hours:10},
      { id:62, value: 'Events calendar', hours:6},
      { id:63, value: 'Meeting widgets', hours:6},
      { id:64, value: 'Chatbot', hours:4},      
      { id:65, value: 'Pop up offers', hours:6},
      { id:66, value: 'Reviews widget', hours:4},
      { id:67, value: 'Testimonials', hours:6},
      { id:68, value: 'Social sharing', hours:2},
      { id:69, value: 'Staff listing', hours:6},
      { id:610, value: 'Video integration', hours:2},
      { id:611, value: 'Portfolio', hours:30},
      { id:612, value: 'SEO', hours:15},
      { id:613, value: 'Overall search', hours:8}
    ]
  }
];